<div id="form_error">
  <div class="form-error-div">
    <img id="error_image" src="/assets/images/api_error.svg" alt="Error" width="100" />
    <h1 id="error_text">Oops!</h1>
    <p id="error_content" class="custom-p">We have encountered some trouble building this form!</p>
  </div>
</div>
